import React from 'react';
import './App.css';

interface LoadingModalProps {
  isVisible: boolean;
  message?: string;
}

const LoadingModal: React.FC<LoadingModalProps> = ({ isVisible, message = "Processing..." }) => {
  if (!isVisible) return null;

  return (
    <div className="loading-modal">
      <div className="loading-content">
        <div className="spinner"></div>
        <p className="loading-text">{message}</p>
      </div>
    </div>
  );
};

export default LoadingModal;